import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M15.4286 8.3973V6.59692C15.4286 4.57148 13.4914 2.55506 11.28 3.08617C9.65143 3.47325 8.57143 5.11161 8.57143 6.85798V8.3973H7.71429C6.77143 8.3973 6 9.20748 6 10.1977V19.1996C6 20.1898 6.77143 21 7.71429 21H16.2857C17.2286 21 18 20.1898 18 19.1996V10.1977C18 9.20748 17.2286 8.3973 16.2857 8.3973H15.4286ZM10.2857 6.59692C10.2857 5.6067 11.0571 4.79653 12 4.79653C12.9429 4.79653 13.7143 5.69672 13.7143 6.59692V8.3973H10.2857V6.59692ZM16.2857 18.2994C16.2857 18.7945 15.9 19.1996 15.4286 19.1996H8.57143C8.1 19.1996 7.71429 18.7945 7.71429 18.2994V11.0979C7.71429 10.6028 8.1 10.1977 8.57143 10.1977H15.4286C15.9 10.1977 16.2857 10.6028 16.2857 11.0979V18.2994Z' />
        </SvgIcon>
    );
});
